import { Box, Paper } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ResetPasswordForm from './components/ResetPasswordForm';
import ResetSuccessful from './components/ResetSuccessful';
import Submitted from './components/Submitted';

/**
 * The view to show the user to help them recover a forgotten password
 */
const ForgotPasswordView = () => {
  const [viewState, setViewState] = useState('forgot-form');
  const [viewComponent, setViewComponent] = useState(<></>);
  const [params] = useSearchParams();
  const code = useMemo(() => params.get('code'), [params]);
  const email = useMemo(() => params.get('email'), [params]);

  useEffect(() => {
    if (code != null && email != null) setViewState('change-password');
    else setViewState('forgot-form');
  }, [code, email]);

  useEffect(() => {
    switch (viewState) {
      // The initial form to show the user on the page
      case 'forgot-form':
        setViewComponent(
          <ForgotPasswordForm setSubmitted={() => setViewState('submitted')} />
        );
        break;
      // The component to show the user when they are actually updating and changing their password
      case 'change-password':
        if (code != null && email != null)
          setViewComponent(
            <ResetPasswordForm
              code={code}
              email={email}
              setSuccessfulReset={() => setViewState('reset-successful')}
            />
          );
        break;
      // The component to show the user when they've successfully submitted a password reset request
      case 'submitted':
        setViewComponent(<Submitted />);
        break;
      // The last component to show in the process when the reset was successful
      case 'reset-successful':
        setViewComponent(<ResetSuccessful />);
    }
  }, [code, email, viewState]);

  return (
    <Box
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: '27em',
          padding: '2em',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          margin: '.5em',
        }}
      >
        {viewComponent}
      </Paper>
    </Box>
  );
};

export default ForgotPasswordView;
